import { jsx, jsxs } from "react/jsx-runtime";
import { Divider } from "@mui/material";
import { Fragment } from "react";
import { ColorGroup } from "./components/ColorGroup.js";
function CustomColorGroups(props) {
  const { customColors } = props;
  const entries = Object.entries(customColors.groups);
  return entries.map(([id, colorGroup]) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider, { sx: { width: "100%" } }),
      /* @__PURE__ */ jsx(ColorGroup, { colorGroup, id, maxSwatches: customColors.maxSwatchesPerGroup })
    ] }, id);
  });
}
export {
  CustomColorGroups
};
//# sourceMappingURL=CustomColorGroups.js.map
